import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";

import typographyStyle from "../../assets/jss/material-kit-pro-react/components/typographyStyle";

function Info({ ...props }) {
    const { classes, children } = props;
    return (
        <div className={classes.defaultFontStyle + " " + classes.infoText}>
            {children}
        </div>
    );
}

Info.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(typographyStyle)(Info);



// WEBPACK FOOTER //
// ./src/components/Typography/Info.jsx